import { render, staticRenderFns } from "./ViAdmissionCreateClass.vue?vue&type=template&id=91a672ec"
import script from "./ViAdmissionCreateClass.vue?vue&type=script&lang=js"
export * from "./ViAdmissionCreateClass.vue?vue&type=script&lang=js"
import style0 from "./ViAdmissionCreateClass.vue?vue&type=style&index=0&id=91a672ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports